/**
 * datalayer.js — Spasiba.com.tr
 * GTM: GTM-MCM6S3RK | sGTM: https://sso.spasiba.com.tr | GA4: G-R47H9E6Y2B
 * Tema: Shrine (özel/premium)
 *
 * Bu dosya theme.liquid içinde </body>'den önce defer ile yüklenir.
 * Tüm JavaScript bazlı GTM/dataLayer event'lerini içerir.
 * Liquid bazlı event'ler snippets/gtm-datalayer.liquid'dedir.
 */
(function () {
  'use strict';

  /* ── TEMEL DEĞİŞKENLER ── */
  var DL       = window.dataLayer = window.dataLayer || [];
  var sgtm     = 'https://sso.spasiba.com.tr';
  var currency = window._shpCurrency || 'TRY';

  /* ────────────────────────────────────────────────────────────────────
     YARDIMCI FONKSİYONLAR
  ──────────────────────────────────────────────────────────────────── */

  /** ecommerce null + push */
  function clearPush(obj) {
    DL.push({ ecommerce: null });
    DL.push(obj);
  }

  /** sGTM /mp/collect'e doğrudan HTTP isteği */
  function sendToSgtm(payload) {
    fetch(sgtm + '/mp/collect', {
      method   : 'POST',
      headers  : { 'Content-Type': 'application/json' },
      body     : JSON.stringify(payload),
      keepalive: true
    }).catch(function () {});
  }

  /** Kısa zaman damgası */
  function ts() { return Date.now(); }

  /** Cookie okuma */
  function getCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[2]) : null;
  }

  /** Tek seferlik tetikleme (drawer açılma gibi çift-push önlemek için) */
  var _firedKeys = {};
  function once(key, fn, ttl) {
    if (_firedKeys[key]) return;
    _firedKeys[key] = true;
    fn();
    setTimeout(function () { delete _firedKeys[key]; }, ttl || 2000);
  }

  /* ────────────────────────────────────────────────────────────────────
     CART STATE — /cart/change ve /cart/update için önceki durum takibi
     window.__cartState = { variantId: cartItem, ... }
  ──────────────────────────────────────────────────────────────────── */
  function snapshotItems(items) {
    var map = {};
    (items || []).forEach(function (i) { map[i.variant_id] = i; });
    return map;
  }

  window.__cartState = {};
  /* Sayfa yüklendiğinde başlangıç state */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      window.__cartState = snapshotItems(cart.items);
      /* Shopify Markets: gerçek para birimini al */
      if (cart.currency) {
        window._shpCurrency = cart.currency;
        currency = cart.currency;
      }
    })
    .catch(function () {});

  /* ────────────────────────────────────────────────────────────────────
     SELECT_ITEM — ürün kartına tıklama
     GTM tag: GA4 Event — select_item
     Shrine selector'ları: .card-wrapper[data-product-card] a
  ──────────────────────────────────────────────────────────────────── */
  var CARD_LINK_SEL = [
    /* Shrine */
    '.card-wrapper a.full-unstyled-link',
    '.card__heading a',
    /* Genel fallback */
    '[data-product-card] a',
    '.product-card a'
  ].join(', ');

  var CARD_SEL = [
    '[data-product-card]',
    '.card-wrapper',
    '.product-card'
  ].join(', ');

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest(CARD_LINK_SEL) : null;
    if (!link) return;
    var card = link.closest(CARD_SEL);
    if (!card || !card.dataset.productTitle) return;

    var allCards = document.querySelectorAll(CARD_SEL);
    var idx      = Array.prototype.indexOf.call(allCards, card);

    clearPush({
      'event': 'select_item',
      'ecommerce': {
        'item_list_id'  : card.dataset.listId   || '',
        'item_list_name': card.dataset.listName || '',
        'items': [{
          'item_id'       : card.dataset.variantSku || card.dataset.variantId || '',
          'item_name'     : card.dataset.productTitle,
          'price'         : parseFloat(card.dataset.price || 0) / 100,
          'currency'      : currency,
          'index'         : idx,
          'item_list_id'  : card.dataset.listId   || '',
          'item_list_name': card.dataset.listName || ''
        }]
      }
    });
    /* GTM tag: GA4 Event — select_item */
  });

  /* ────────────────────────────────────────────────────────────────────
     VARYANT DEĞİŞİMİ — view_item tekrar tetikle
     GTM tag: GA4 Event — view_item | Meta CAPI — ViewContent

     Shrine 4 yöntemle algılar:
     1. variant:changed (Shrine custom event — birincil)
     2. popstate (URL değişimi — fallback 1)
     3. select[name="id"] change (klasik form — fallback 2)
     4. MutationObserver fiyat değişimi (headless — fallback 3)
  ──────────────────────────────────────────────────────────────────── */
  var _lastVid = null;

  function handleVariantChange(variantId) {
    if (!window._shpProduct) return;
    var vid = String(variantId);
    if (vid === _lastVid) return;
    _lastVid = vid;

    var variant = window._shpProduct.variants[vid];
    if (!variant) return;

    clearPush({
      'event'    : 'view_item',
      'event_id' : 'vi_' + window._shpProduct.id + '_' + variant.id,
      'ecommerce': {
        'currency': window._shpProduct.currency || currency,
        'value'   : variant.price,
        'items'   : [{
          'item_id'      : variant.sku || String(variant.id),
          'item_name'    : window._shpProduct.title,
          'item_brand'   : window._shpProduct.vendor,
          'item_category': window._shpProduct.type,
          'item_variant' : variant.title,
          'price'        : variant.price,
          'currency'     : window._shpProduct.currency || currency,
          'availability' : variant.available ? 'in_stock' : 'out_of_stock'
        }]
      }
    });
    /* GTM tag: GA4 Event — view_item | Meta CAPI — ViewContent */
  }

  /* Yöntem 1: Shrine primary event */
  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    if (v) handleVariantChange(v.id);
  });

  /* Yöntem 2: URL polling fallback */
  function checkUrlVariant() {
    var p = new URLSearchParams(window.location.search);
    var v = p.get('variant');
    if (v) handleVariantChange(v);
  }
  window.addEventListener('popstate', checkUrlVariant);

  /* Yöntem 3: select/input change */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && (t.name === 'id' || (t.classList && t.classList.contains('variant-select')))) {
      handleVariantChange(t.value);
    }
  });

  /* Yöntem 4: MutationObserver — fiyat DOM değişimi */
  var _priceEl = document.querySelector(
    '.price__regular .price-item, .product__price, [data-regular-price], .price-item--regular'
  );
  if (_priceEl && window._shpProduct) {
    new MutationObserver(function () {
      var sel = document.querySelector('input[name="id"]:checked, select[name="id"]');
      if (sel) handleVariantChange(sel.value);
    }).observe(_priceEl, { childList: true, characterData: true, subtree: true });
  }

  /* ────────────────────────────────────────────────────────────────────
     ADD_TO_CART + REMOVE_FROM_CART — fetch intercept
     GTM tag: GA4 add_to_cart | Meta CAPI — AddToCart | Google Ads Remarketing
              GA4 remove_from_cart
  ──────────────────────────────────────────────────────────────────── */
  var _origFetch = window.fetch;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input
            : (input && input.url ? input.url : '');

    /* ── /cart/add ── */
    if (url.indexOf('/cart/add') !== -1) {
      return _origFetch.apply(this, arguments).then(function (res) {
        res.clone().json().then(function (data) {
          if (!data || !data.variant_id) return;
          var cur = data.currency || window._shpCurrency || currency;
          clearPush({
            'event'    : 'add_to_cart',
            'event_id' : 'atc_' + data.variant_id + '_' + ts(),
            'ecommerce': {
              'currency': cur,
              'value'   : (data.final_line_price || data.price) / 100,
              'items'   : [{
                'item_id'      : data.sku || String(data.variant_id),
                'item_name'    : data.product_title,
                'item_brand'   : data.vendor || '',
                'item_category': data.product_type || '',
                'item_variant' : data.variant_title || '',
                'price'        : data.price / 100,
                'quantity'     : data.quantity,
                'currency'     : cur
              }]
            }
          });
          /* GTM tag: GA4 add_to_cart | Meta CAPI AddToCart | Google Ads Remarketing */

          /* Cart state'i güncelle */
          fetch('/cart.js').then(function (r) { return r.json(); })
            .then(function (c) { window.__cartState = snapshotItems(c.items); })
            .catch(function () {});
        }).catch(function () {});
        return res;
      });
    }

    /* ── /cart/change veya /cart/update — remove_from_cart ── */
    if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
      var prevState = JSON.parse(JSON.stringify(window.__cartState || {}));
      return _origFetch.apply(this, arguments).then(function (res) {
        res.clone().json().then(function (newCart) {
          if (!newCart || !newCart.items) return;
          var cur      = newCart.currency || window._shpCurrency || currency;
          var newState = snapshotItems(newCart.items);
          var removed  = [];

          /* Miktarı azalanlar */
          newCart.items.forEach(function (item) {
            var prev    = prevState[item.variant_id];
            var prevQty = prev ? prev.quantity : 0;
            var diff    = item.quantity - prevQty;
            if (diff < 0) {
              removed.push({
                'item_id'      : item.sku || String(item.variant_id),
                'item_name'    : item.product_title,
                'item_variant' : item.variant_title || '',
                'price'        : item.final_price / 100,
                'quantity'     : Math.abs(diff),
                'currency'     : cur
              });
            }
          });

          /* Tamamen çıkarılanlar */
          Object.keys(prevState).forEach(function (vid) {
            if (!newState[vid]) {
              var r = prevState[vid];
              removed.push({
                'item_id'      : r.sku || String(r.variant_id),
                'item_name'    : r.product_title,
                'item_variant' : r.variant_title || '',
                'price'        : r.final_price / 100,
                'quantity'     : r.quantity,
                'currency'     : cur
              });
            }
          });

          window.__cartState = newState;
          if (cur) { window._shpCurrency = cur; currency = cur; }

          if (removed.length === 0) return;
          var totalVal = removed.reduce(function (s, i) { return s + i.price * i.quantity; }, 0);
          clearPush({
            'event'    : 'remove_from_cart',
            'event_id' : 'rfc_' + ts(),
            'ecommerce': {
              'currency': cur,
              'value'   : parseFloat(totalVal.toFixed(2)),
              'items'   : removed
            }
          });
          /* GTM tag: GA4 Event — remove_from_cart */
        }).catch(function () {});
        return res;
      });
    }

    return _origFetch.apply(this, arguments);
  };

  /* ────────────────────────────────────────────────────────────────────
     VIEW_CART — Shrine cart-drawer açılışı
     GTM tag: GA4 Event — view_cart
     Shrine: <cart-drawer> custom element, class="active" eklendiğinde açık
  ──────────────────────────────────────────────────────────────────── */
  function fetchAndPushViewCart() {
    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        var cur = cart.currency || window._shpCurrency || currency;
        clearPush({
          'event'    : 'view_cart',
          'ecommerce': {
            'currency': cur,
            'value'   : cart.total_price / 100,
            'coupon'  : cart.cart_level_discount_applications && cart.cart_level_discount_applications[0]
                        ? cart.cart_level_discount_applications[0].title : '',
            'items'   : cart.items.map(function (i) {
              return {
                'item_id'      : i.sku || String(i.variant_id),
                'item_name'    : i.product_title,
                'item_brand'   : i.vendor || '',
                'item_category': i.product_type || '',
                'item_variant' : i.variant_title || '',
                'price'        : i.final_price / 100,
                'quantity'     : i.quantity,
                'currency'     : cur
              };
            })
          }
        });
        /* GTM tag: GA4 Event — view_cart */
      }).catch(function () {});
  }

  /* Shrine drawer: <cart-drawer class="..."> */
  var _drawerEl = document.querySelector('cart-drawer');
  if (_drawerEl) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName !== 'class') return;
        var open = _drawerEl.classList.contains('active');
        if (open) once('view_cart_drawer', fetchAndPushViewCart, 3000);
      });
    }).observe(_drawerEl, { attributes: true });
  }

  /* Fallback: aria-hidden veya genel drawer pattern'ler */
  var _genericDrawer = document.querySelector(
    '#cart-drawer, [data-cart-drawer], .js-drawer[data-drawer="cart"]'
  );
  if (_genericDrawer && !_drawerEl) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        var el   = m.target;
        var open = el.getAttribute('aria-hidden') === 'false'
                || el.classList.contains('is-open')
                || el.hasAttribute('open');
        if (open) once('view_cart_drawer', fetchAndPushViewCart, 3000);
      });
    }).observe(_genericDrawer, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'open']
    });
  }

  /* ────────────────────────────────────────────────────────────────────
     BEGIN_CHECKOUT
     GTM tag: GA4 begin_checkout | Meta CAPI InitiateCheckout | Google Ads
  ──────────────────────────────────────────────────────────────────── */
  var _checkoutFired = false;

  function fireBeginCheckout() {
    if (_checkoutFired) return;
    _checkoutFired = true;
    setTimeout(function () { _checkoutFired = false; }, 5000);

    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        var cur = cart.currency || window._shpCurrency || currency;
        clearPush({
          'event'    : 'begin_checkout',
          'event_id' : 'checkout_' + cart.token,
          'ecommerce': {
            'currency': cur,
            'value'   : cart.total_price / 100,
            'coupon'  : cart.cart_level_discount_applications && cart.cart_level_discount_applications[0]
                        ? cart.cart_level_discount_applications[0].title : '',
            'items'   : cart.items.map(function (i, idx) {
              return {
                'item_id'      : i.sku || String(i.variant_id),
                'item_name'    : i.product_title,
                'item_brand'   : i.vendor || '',
                'item_category': i.product_type || '',
                'item_variant' : i.variant_title || '',
                'price'        : i.final_price / 100,
                'quantity'     : i.quantity,
                'currency'     : cur,
                'index'        : idx
              };
            })
          }
        });
        /* GTM tag: GA4 begin_checkout | Meta CAPI InitiateCheckout | Google Ads */
      }).catch(function () {});
  }

  /* Shrine checkout butonu #CartDrawer-Checkout + genel fallback'ler */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest
      ? e.target.closest([
          '#CartDrawer-Checkout',
          '[name="checkout"]',
          '[href="/checkout"]',
          '.cart__checkout',
          '[data-checkout]'
        ].join(','))
      : null;
    if (btn) fireBeginCheckout();
  });

  /* Zaten /checkout URL'inde açılmışsa */
  if (window.location.pathname.indexOf('/checkouts/') !== -1 ||
      window.location.pathname === '/checkout') {
    fireBeginCheckout();
  }

  /* ────────────────────────────────────────────────────────────────────
     ADD_TO_WISHLIST (varsa — selector'lar temaya göre özelleştir)
     GTM tag: GA4 add_to_wishlist | Meta CAPI AddToWishlist
  ──────────────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest
      ? e.target.closest(
          '[data-wishlist-add], .wishlist-btn, [aria-label*="wishlist"],' +
          '[aria-label*="favori"], .btn-wishlist, .wishlist-button'
        )
      : null;
    if (!btn) return;

    var card    = btn.closest('[data-product-card], .card-wrapper');
    var section = btn.closest('[data-product-id], .product-section');
    var src     = card || section || btn;

    var itemId   = (src && src.dataset.variantSku) || (src && src.dataset.variantId) || '';
    var itemName = (src && src.dataset.productTitle) || '';
    var price    = parseFloat((src && src.dataset.price) || 0) / 100;

    /* Ürün sayfasında window._shpProduct'tan al */
    if (!itemId && window._shpProduct) {
      var selEl = document.querySelector('input[name="id"]:checked, select[name="id"]');
      if (selEl) {
        var v = window._shpProduct.variants[selEl.value];
        if (v) {
          itemId   = v.sku || String(v.id);
          itemName = window._shpProduct.title;
          price    = v.price;
        }
      }
    }
    if (!itemId) return;

    clearPush({
      'event'    : 'add_to_wishlist',
      'event_id' : 'wishlist_' + itemId + '_' + ts(),
      'ecommerce': {
        'currency': currency,
        'value'   : price,
        'items'   : [{
          'item_id'  : itemId,
          'item_name': itemName,
          'price'    : price,
          'currency' : currency
        }]
      }
    });
    /* GTM tag: GA4 add_to_wishlist | Meta CAPI AddToWishlist */
  });

  /* ────────────────────────────────────────────────────────────────────
     SCROLL DEPTH
     GTM tag: GA4 Event — scroll
  ──────────────────────────────────────────────────────────────────── */
  var _scrollFired = { 25: false, 50: false, 75: false, 90: false };
  window.addEventListener('scroll', function () {
    var pct = (window.scrollY / Math.max(1,
      document.documentElement.scrollHeight - window.innerHeight)) * 100;
    [25, 50, 75, 90].forEach(function (t) {
      if (pct >= t && !_scrollFired[t]) {
        _scrollFired[t] = true;
        DL.push({ 'event': 'scroll', 'percent_scrolled': t, 'page_path': window.location.pathname });
        /* GTM tag: GA4 Event — scroll */
      }
    });
  }, { passive: true });

  /* ────────────────────────────────────────────────────────────────────
     ÜRÜN KARTLARINA DATA ATTRIBUTE ZENGİNLEŞTİRME
     Shrine: data-product-card attribute ile Liquid'den geliyor.
     Bu fonksiyon AJAX/infinite scroll'da yeni yüklenen kartları günceller.
  ──────────────────────────────────────────────────────────────────── */
  function enrichCards() {
    document.querySelectorAll('[data-product-card]:not([data-dl-enriched])').forEach(function (card) {
      card.dataset.dlEnriched = '1';
      /* list bilgisi body dataset'ten al (collection sayfalarında) */
      if (!card.dataset.listId) {
        card.dataset.listId   = document.body.dataset.collectionHandle || 'unknown';
        card.dataset.listName = document.body.dataset.collectionTitle  || document.title;
      }
    });
  }
  enrichCards();

  /* Infinite scroll / AJAX pagination için gözlemci */
  var _grid = document.querySelector(
    '.product-grid, .collection-grid, [data-product-grid], product-recommendations'
  );
  if (_grid) {
    new MutationObserver(enrichCards).observe(_grid, { childList: true, subtree: false });
  }

})();
